import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestOption } from '../model/common.model';
import { UtilitiesService } from './../../core/services/utilities.service';
import { API_URL } from './../enums/api-enums';
import { GetAllResponse, SingleResponse } from './../model/restful-api.model';

@Injectable({
  providedIn: 'root'
})
export class UserSupplierService {

  baseUrl = `${environment.portalURL}`;
  constructor(
    private util: UtilitiesService,
    private http: HttpClient
  ) { }

  checkSSO(sso: string, type): Observable<GetAllResponse<any>> {
    const url = this.baseUrl + '/' + type + '/search?sso=' + sso;
    return this.util.req.httpGet<GetAllResponse<any>>(url);
  }

  addNewSupplier(requestModel, type): Observable<GetAllResponse<any>> {
    const url = this.baseUrl + '/' + type;
    return this.util.req.httpPost(url, requestModel);
  }

  updateSupplier(requestModel, type): Observable<GetAllResponse<any>> {
    const url = this.baseUrl + '/' + type;
    return this.util.req.httpPut(url, requestModel);
  }

  deleteUser(id, type): Observable<SingleResponse<any>> {
    return this.util.req.httpDelete(this.baseUrl + '/' + type + '/' + id);
  }

  getSupplierByTypeAndId(type, id): Observable<SingleResponse<any>> {
    const url = this.baseUrl + '/' + type + '/' + id;
    return this.util.req.httpGet<SingleResponse<any>>(url);
  }

  changeActiveByType(type, model): Observable<SingleResponse<any>> {
    const url = this.baseUrl + '/' + type + '/activate';
    return this.util.req.httpPut(url, model);
  }

  getGSLInfoByType(name, value, type): Observable<GetAllResponse<any>> {
    return this.util.req.httpGet(`${this.baseUrl + '/' + type + API_URL.GLSINFO}?${name}=${encodeURI(value)}`);
  }

  search(requestOption: RequestOption, search, status, type, gsl?, parentName?): Observable<SingleResponse<any>> {
    let params = new HttpParams();
    if (search) {
      params = params.append('searchKey', search);
    }
    if (gsl) {
      params = params.append('gslNumber', gsl);
    }
    if (parentName) {
      params = params.append('parentCompanyName', parentName);
    }
    params = params.append('status', status);
    if (requestOption.pagingOptions.sort.sortBy && requestOption.pagingOptions.sort.sortOrder) {
      params = params.append('sortBy', requestOption.pagingOptions.sort.sortBy);
      params = params.append('sortDirection', requestOption.pagingOptions.sort.sortOrder);
    }
    params = params.append('size', requestOption.pagingOptions.size.toString());
    params = params.append('page', requestOption.pagingOptions.number.toString());

    return this.util.req.httpGet<SingleResponse<any>>(`${this.baseUrl}/${type}?${params}`);
  }

  exportUser(type) {
    // type: external_supplier or internal_user
    return this.http.get(`${this.baseUrl}/${type}/export`, {responseType: 'arraybuffer'});
  }
}
